import Phaser from 'phaser';
export default class OrientationCheck extends Phaser.Scene {
    constructor() {
        super({ key: 'OrientationCheck'});
        this.wasFullScreen = false;
    }

    create() {
        this.gameW = this.cameras.main.width;
        this.gameH = this.cameras.main.height;
        this.wasFullScreen = false;
        // Listen for orientation changes
        window.addEventListener('resize', orientationFix);
    }
}

// Keep this as a global function since it references the orientationCheck scene
var orientationFix = function () {
    if (window.innerHeight > window.innerWidth) {
        // Portrait mode
        if (document.fullscreenElement) {
            document.exitFullscreen().then(() => {
                orientationCheck.wasFullScreen = true;

                console.log('Exited full screen mode');
            }).catch((err) => {
                console.error(`Failed to exit full screen mode: ${err.message}`);
            });
        }

        
    } else {

        //console.log('Landscape mode' + window.innerWidth + ' ' + window.innerHeight + ' ' + game.config.width + ' ' + game.config.height);
        // Landscape mode
        if (orientationCheck.wasFullScreen) {
            
            setTimeout(() => {

            }, 500);
        }
    }
}

// Initialize the scene reference for global access
let orientationCheck = new OrientationCheck();